module.exports = __webpack_public_path__ + "img/live.4a11f1de.png";